// extracted by mini-css-extract-plugin
module.exports = {"estimated":"src-components-planSelection-plan-module__estimated--3PJTF"};